import * as THREE from "three";

function plusTexture() {
  const c = document.createElement("canvas");
  c.width = c.height = 64;
  const g = c.getContext("2d");
  g.strokeStyle = "rgba(255,255,255,0.95)";
  g.lineWidth = 3.5;
  g.beginPath();
  g.moveTo(32, 14); g.lineTo(32, 50);
  g.moveTo(14, 32); g.lineTo(50, 32);
  g.stroke();
  const tex = new THREE.CanvasTexture(c);
  return tex;
}

// Loose sensor-constellation of plus markers and thin link lines around the satellite.
export function createConstellation() {
  const pts = [
    [0, 0.1, 0], [0.95, 0.52, -0.3], [1.75, 0.18, 0.2], [1.35, -0.58, -0.25],
    [0.4, -0.92, 0.3], [-0.65, 0.72, -0.4], [-1.25, 0.2, 0.5], [0.25, 1.15, 0.1],
    [2.2, 0.7, 0.35], [-0.4, -0.5, -0.6],
  ];
  const links = [[0, 1], [1, 2], [2, 3], [3, 4], [4, 0], [1, 7], [6, 0], [2, 8], [6, 5], [5, 7], [3, 9]];

  const linesGeo = new THREE.BufferGeometry();
  const linePos = new Float32Array(links.length * 6);
  links.forEach(([a, b], i) => {
    linePos.set([...pts[a], ...pts[b]], i * 6);
  });
  linesGeo.setAttribute("position", new THREE.BufferAttribute(linePos, 3));
  const lineMat = new THREE.LineBasicMaterial({
    color: 0xdfe8ff,
    transparent: true,
    opacity: 0.3,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    depthTest: false,
  });
  const lines = new THREE.LineSegments(linesGeo, lineMat);
  lines.renderOrder = 1;

  const tex = plusTexture();
  const spriteMat = new THREE.SpriteMaterial({
    map: tex,
    transparent: true,
    opacity: 0.75,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    depthTest: false,
  });
  const group = new THREE.Group();
  group.add(lines);
  pts.forEach((p, i) => {
    const s = new THREE.Sprite(spriteMat);
    s.position.set(...p);
    const sc = 0.09 + (i % 3) * 0.03;
    s.scale.set(sc, sc, 1);
    s.renderOrder = 1;
    group.add(s);
  });

  const update = (t) => {
    const pulse = 0.86 + 0.14 * Math.sin(t * 1.1);
    lineMat.opacity = 0.3 * pulse;
    spriteMat.opacity = 0.75 * pulse;
  };

  return { group, update, lineMat, spriteMat };
}
